var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"cashTitle clearfix"},[_c('div',{staticClass:"fl"},[_c('span',{staticClass:"tips"},[_vm._v(" "+_vm._s(_vm.$t('cashamount'))+"（￥）：230")]),_c('span',{staticClass:"mainColor"},[_vm._v("提现")])]),_c('div',{staticClass:"fr mainColor cursor"},[_vm._v("提现记录")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }